import { colors } from '@mui/material'
import { TokenAmount, TokenAmountProps } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'

import { useAuction, useAuctionPrice } from '../Contexts'

export interface TokenPriceProps extends TokenAmountProps {
  logo?: boolean
  quadkey?: Quadkey
}

export const TokenPrice: React.FC<TokenPriceProps> = ({ logo, quadkey, ...props }) => {
  const { auction } = useAuction(quadkey)
  const price = useAuctionPrice()
  if (auction && price !== undefined) {
    const color: string = auction.static?.minted
      ? colors.grey[500]
      : auction.isDutch()
      ? colors.orange[500]
      : auction.isExpired()
      ? colors.yellow[500]
      : colors.green[500]
    return <TokenAmount amount={price} textColor={color} logo={logo} {...props} />
  }
  return <TokenAmount />
}
